<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-2">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-2 text-primary">سطوح و امتیازات</h3>
                <div class="mb-2">
                    <b-button @click="customersFindModal" variant="primary" class="px-2">
                        <span>افزایش سطح</span>
                    </b-button>
                </div>
            </div>
            <b-row>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="نام یا شماره اشتراک" label-for="searchCustomer">
                        <v-select dir="rtl" v-model="searchCustomer" :options="customerList" :filterable="false"
                            style="border-radius: 6px;" class="bg-white" :clearable="false" id="searchCustomer"
                            @search="handleSearchCustomer" :loading="loadingCustomer"
                            :get-option-label="(option) => option.number + ' - ' + option.firstName + ' ' + option.lastName">
                            <template #option="{ number, firstName, lastName, phoneNumber }">
                                <div class="d-flex align-items-center">
                                    <div>{{ number }}</div>
                                    <span class="mx-50">-</span>
                                    <div class="mr-50">{{ firstName }}</div>
                                    <div>{{ lastName }}</div>
                                    <span class="mx-50">/</span>
                                    <div>{{ phoneNumber }}</div>
                                </div>
                            </template>
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                            <template #spinner="{ loading }">
                                <div v-if="loadingCustomer" style="border-right-color: #7367f0" class="vs__spinner">
                                </div>
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="تاریخ شروع" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="تاریخ پایان" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                        <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="نوع" label-for="typeId">
                        <v-select v-model="parameters.type" :searchable="false" dir="rtl" :options="typeManagement"
                            class="bg-white" id="isReturnedId" autocomplete="off" :reduce="(value) => value.id"
                            style="border-radius: 6px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="کاربر تغییر دهنده" label-for="userIdId">
                        <v-select v-model="parameters.storeUserId" dir="rtl" :options="usersList" id="userIdId"
                            class="bg-white" autocomplete="off" :reduce="(value) => value.id"
                            style="border-radius: 6px;"
                            :get-option-label="(option) => option.firstName + ' ' + option.lastName" :clearable="false">
                            <template #option="{ firstName, lastName }">
                                {{ firstName }} {{ lastName }}
                            </template>
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="2" md="3" class="mt-md-2 mt-50">
                    <b-button @click="removeFilters" variant="secondary"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100" :disabled="loading">
                        <span>حذف فیلتر ها</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
                <b-col lg="2" md="3" class="mt-md-2 mt-1">
                    <b-button variant="info" @click="customersScoreRecords" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <div class="mt-2 mt-md-1">
                <b-card class="p-0" no-body>
                    <b-overlay v-if="scoreRecords.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                        rounded="sm">
                        <b-table responsive :items="scoreRecords" :fields="fields" class="mb-0" striped>
                            <template #cell(type)="data">
                                {{ type_management(data.item.type) }}
                            </template>
                            <template #cell(nextLoyaltyLevel)="data">
                                {{ data.item.nextLoyaltyLevel ? data.item.nextLoyaltyLevel : '-' }}
                            </template>
                            <template #cell(previousLoyaltyLevel)="data">
                                {{ data.item.previousLoyaltyLevel ? data.item.previousLoyaltyLevel : '-' }}
                            </template>
                            <template #cell(customer)="data">
                                {{ `${data.item.customer.firstName} ${data.item.customer.lastName}` }}
                            </template>
                            <template #cell(nextLoyaltyLevelNumber)="data">
                                {{ data.item.nextLoyaltyLevelNumber ? data.item.nextLoyaltyLevelNumber :
                                    data.item.previousLoyaltyLevelNumber }}
                            </template>
                            <template #cell(createdByStoreUser)="data">
                                <span v-if="data.item.createdByStoreUser">
                                    {{ `${data.item.createdByStoreUser.firstName}
                                    ${data.item.createdByStoreUser.lastName}` }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </template>
                            <template #cell(customer.number)="data">
                                {{ data.item.customer.number }}
                            </template>
                            <template #cell(createdAt)="data">
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                        </b-table>
                    </b-overlay>
                    <div v-else class="text-center py-4">
                        موردی وجود ندارد
                    </div>
                </b-card>
                <b-pagination align="center" @input="customersScoreRecords" v-model="parameters.pageIndex"
                    :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
            </div>

            <!------------------------------- modal customers find ------------------------------->
            <b-modal id="customers-find" title="جستجو مشتری" centered :hide-footer="true"
                title-class="font-weight-bolder" size="sm">
                <div class="p-1">
                    <validation-observer ref="customersFindValidation">
                        <b-form @submit.prevent>
                            <b-form-group label="شماره همراه" label-for="phone" class="text-center">
                                <validation-provider #default="{ errors }" name="شماره همراه"
                                    rules="phoneNumber|required">
                                    <cleave id="phone" dir="ltr" v-model="customerPhoneNumber" autocomplete="off"
                                        class="form-control text-center font-weight-bolder"
                                        :class="{ 'border-danger': errors.length > 0 }" :options="options.phone" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-button type="submit" variant="info" @click="customersFind" :disabled="loadingButton"
                                class="w-100 mt-2 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>جستجو</span>
                            </b-button>
                        </b-form>
                    </validation-observer>
                </div>
            </b-modal>

            <!------------------------------- modal create customer ------------------------------->
            <b-modal id="increase-customer-level" title="افزایش سطح مشتری" centered :hide-footer="true"
                title-class="font-weight-bolder" size="sm">
                <div class="p-1">
                    <b-row>
                        <b-col md="12">
                            <b-form-group label="انتخاب سطح مشتری" label-for="customerClubInformation"
                                class="text-center">
                                <v-select dir="rtl" v-model="customerClubInformation" :options="loyaltySystemLevels"
                                    :selectable="option => option.number > customerData.loyaltyInfo.loyaltyLevel.number"
                                    id="customerClubInformation" :clearable="false" :searchable="false"
                                    autocomplete="off" :get-option-label="(option) => `سطح ${option.number}`">
                                    <template #option="{ number }">
                                        <div class="d-flex align-items-center">
                                            <div>{{ `سطح ${number}` }}</div>
                                        </div>
                                    </template>
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="12" class="mt-2" v-if="customerData">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">نام مشتری</h5>
                                    <h4 class="mb-0">{{ `${customerData.firstName} ${customerData.lastName}` }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="UserIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col md="12" class="mt-2" v-if="customerData">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">شماره همراه</h5>
                                    <h4 class="mb-0">{{ customerData.phoneNumber }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="UserIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col md="12" class="mt-2" v-if="customerData">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">شماره اشتراک</h5>
                                    <h4 class="mb-0">{{ customerData.number }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="UserIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col md="12" class="mt-2" v-if="customerData.loyaltyInfo">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">نام سطح</h5>
                                    <h4 class="mb-0">{{ customerData.loyaltyInfo.loyaltyLevel.name }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="UserIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col md="12" class="mt-2" v-if="customerData.loyaltyInfo">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">شماره سطح</h5>
                                    <h4 class="mb-0">{{ customerData.loyaltyInfo.loyaltyLevel.number }}
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="UserIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col md="12" class="mt-50">
                            <b-button type="submit" variant="primary" @click="editScoreCustomer"
                                :disabled="loadingButton || !customerClubInformation"
                                class="w-100 mt-2 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>تایید</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
        </div>

        <b-card v-else>
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BBadge, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BFormFile, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.ir'
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BBadge,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BFormFile,
        vSelect
    },
    mixins: [accessHandling],
    data() {
        return {
            options: {
                phone: {
                    phone: true,
                    phoneRegionCode: 'IR',
                    delimiter: '-',
                }
            },
            isAdminIdentityVerified: false,
            required,
            loadingButton: false,
            loadingPage: true,
            loading: false,
            currentDate: '',
            storeId: null,
            customerPhoneNumber: null,
            customerData: {},
            loyaltySystemLevels: {},
            customerClubInformation: null,
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                storeUserId: null,
                type: null,
                from: null,
                to: null,
                customerId: null,
            },
            scoreRecords: [],
            fields: [
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'customer.number',
                    label: 'شماره اشتراک',
                },
                {
                    key: 'customer',
                    label: 'نام',
                },
                {
                    key: 'previousScore',
                    label: 'امتیاز قبل تغییر',
                },
                {
                    key: 'score',
                    label: 'امتیاز اضافه شده',
                },
                {
                    key: 'nextScore',
                    label: 'امتیاز بعد تغییر',
                },
                {
                    key: 'previousLoyaltyLevelNumber',
                    label: 'سطح قبل تغییر',
                },
                {
                    key: 'nextLoyaltyLevelNumber',
                    label: 'سطح بعد تغییر',
                },
                {
                    key: 'createdByStoreUser',
                    label: 'کاربر تغییر دهنده',
                },
                {
                    key: 'type',
                    label: 'نوع',
                },
            ],
            customerList: [],
            loadingCustomer: false,
            searchCustomer: null,
            debounceTimeout: null,
            parametersCustomer: {
                pageIndex: 1,
                pageSize: 90,
                searchTerm: null,
            },
            usersList: [],
            parametersUsers: {
                pageIndex: 1,
                pageSize: 90,
            },
            typeManagement: [
                { name: 'نمایش همه', id: null },
                { name: 'ثبت سفارش', id: 0 },
                { name: 'تنظیم دستی', id: 1 },
                { name: 'ثبت نظر', id: 2 }
            ],
        }
    },
    computed: {
        type_management() {
            return (status) => {
                if (status == 0) {
                    return 'ثبت سفارش'
                }
                if (status == 1) {
                    return 'تنظیم دستی'
                }
                if (status == 2) {
                    return 'ثبت نظر'
                }
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        removeFilters() {
            this.searchCustomer = null;
            this.parametersCustomer.searchTerm = null;
            this.parameters.storeUserId = null;
            this.parameters.type = null;
            this.parameters.from = null;
            this.parameters.to = null;
            this.parameters.customerId = null;
            this.customersScoreRecords()
        },
        handleSearchCustomer(searchTerm) {
            this.loadingCustomer = true
            clearTimeout(this.debounceTimeout)
            if (!searchTerm) {
                this.customerList = []
                this.loadingCustomer = false
                return
            }
            this.debounceTimeout = setTimeout(() => {
                this.getCustomers(searchTerm)
            }, 1000)
        },
        getCustomers(searchTerm) {
            this.parametersCustomer.searchTerm = searchTerm
            storeService.getCustomers(this.storeId, this.parametersCustomer).then(({ data }) => {
                this.customerList = data.items
                this.loadingCustomer = false
            })
        },
        customersFindModal() {
            if (this.accessHandling('employee', 'customer_level_increase')) {
                this.customerPhoneNumber = null
                this.customerClubInformation = null
                this.$bvModal.show('customers-find')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        customersFind() {
            this.$refs.customersFindValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.customersFind(this.storeId, this.customerPhoneNumber).then(({ data }) => {
                        if (data.isExists) {
                            this.customerData = data.customer
                            this.$refs.customersFindValidation.reset();
                            this.$bvModal.hide('customers-find')
                            this.$bvModal.show('increase-customer-level')
                        }
                        else {
                            this.$notif({ type: 'normal', title: 'مشتری با این شماره یافت نشد' });
                        }
                        this.loadingButton = false
                    })
                        .catch(() => {
                            this.$refs.customersFindValidation.reset();
                            this.loadingButton = false
                        });
                }
            });
        },
        getUsers() {
            storeService.getUsers(this.storeId, this.parametersUsers).then(({ data }) => {
                this.usersList = data.items
                this.usersList.unshift({
                    id: null,
                    lastName: '',
                    firstName: 'نمایش همه'
                })
            })
            this.customersScoreRecords()
        },
        customersScoreRecords() {
            this.loading = true;
            if (this.searchCustomer) {
                this.parameters.customerId = this.searchCustomer.id
            }
            storeService.customersScoreRecords(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.scoreRecords = data.items
                    this.loading = false;
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.scoreRecords = data.items
                        this.loading = false;
                    }, 369)
                }
                this.loadingPage = false;
            })
        },
        getLoyaltySystem() {
            storeService.getLoyaltySystem(this.storeId).then(({ data }) => {
                this.loyaltySystemLevels = data.levels
                this.getUsers()
            })
        },
        editScoreCustomer() {
            this.loadingButton = true
            storeService.editScoreCustomer(this.storeId, this.customerData.id, { score: this.customerClubInformation.min }).then(({ data }) => {
                this.loadingButton = false
                this.$notif({ type: 'success', title: 'سطح مشتری با موفقیت افزایش یافت' });
                this.$bvModal.hide('increase-customer-level')
                this.customersScoreRecords()
            })
                .catch(() => {
                    this.loadingButton = false
                });
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getLoyaltySystem()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const tomorrow = new Date();
        const today = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>